import PropTypes from 'prop-types';
import { useLogEnteredPage } from './step-flow-provider-with-context';

export const BasicStepLogger = ({
  flow, subflow, Page,
}) => {
  useLogEnteredPage({ Flow: flow, SubFlow: subflow, Page: Page || 'unknown step' });
  return null;
};

BasicStepLogger.propTypes = {
  flow: PropTypes.string.isRequired,
  Page: PropTypes.string.isRequired,
  subflow: PropTypes.string,
};
BasicStepLogger.defaultProps = {
  subflow: '',
};
